import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Modal, Header, Form, Button, Icon, Checkbox } from 'semantic-ui-react'

import RestaurantsField from './fields/restaurantsField'
import BranchesField from './fields/branchesField'
import DeliveryDiscountField from './fields/deliveryDiscountField'
import ProfitMarginField from './fields/profitMarginField'

export default class DeliveryFeeOfferForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    selectedMerchant: null,
    selectedBranch: null,
    active: false,
    smallOrderFee: false,
    deliveryDiscount: 0,
    profitMargin: 0,
    createdAt: Number(moment().format('x')),
    saving: false,
  }

  componentDidMount() {
    const { deliveryFeeOffer, action } = this.props

    if (action === 'edit') {
      this.setState({
        selectedMerchant: deliveryFeeOffer.merchant,
        selectedBranch: deliveryFeeOffer.branch,
        active: deliveryFeeOffer.active,
        smallOrderFee: deliveryFeeOffer.small_order_fee,
        deliveryDiscount: deliveryFeeOffer.delivery_discount,
        profitMargin: deliveryFeeOffer.profit_margin,
        createdAt: deliveryFeeOffer.created_at,
      })
    }
  }

  generateMerchantBranches = () => {
    const { selectedMerchant } = this.state
    const { restaurants, deliveryFeeOffers } = this.props

    const allDeliveryFeeOfferBranch = _.map(deliveryFeeOffers, 'branch')
    const { branches } = restaurants[selectedMerchant] || {}

    const allBranches = _.reduce(
      branches,
      (result, branch, key) => {
        if (!allDeliveryFeeOfferBranch.includes(key)) {
          result.push({
            text: branch.name,
            value: key,
          })
        }

        return result
      },
      []
    )

    return allBranches
  }

  validateFields = () => {
    const { selectedMerchant, selectedBranch, deliveryDiscount } = this.state

    if (!selectedMerchant) throw new Error('Please select Merchant.')

    if (!selectedBranch) throw new Error('Please select Branch.')

    if (deliveryDiscount === 0) throw new Error('Delivery Discount should be bigger than 0.')

    return true
  }

  onSavePress = () => {
    const {
      selectedMerchant,
      selectedBranch,
      active,
      smallOrderFee,
      deliveryDiscount,
      profitMargin,
      createdAt,
    } = this.state
    const { authData, onClose, deliveryFeeOffer, saveDeliveryFeeOffer } = this.props

    try {
      this.validateFields()

      this.setState({ saving: true })
  
      const data = {
        active,
        merchant: selectedMerchant,
        branch: selectedBranch,
        small_order_fee: smallOrderFee,
        delivery_discount: deliveryDiscount,
        profit_margin: profitMargin,
        region: authData.region,
        created_at: createdAt,
      }

      saveDeliveryFeeOffer(data, deliveryFeeOffer)
      this.setState({ saving: false }, () => onClose())

      return true
    } catch (err) {
      return alert(err.message || err)
    }
  }

  render() {
    const {
      selectedMerchant,
      selectedBranch,
      active,
      smallOrderFee,
      deliveryDiscount,
      profitMargin,
      saving,
    } = this.state
    const { onClose, action, restaurants } = this.props

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'new' ? 'Add New Delivery Fee Offer' : 'Update Delivery Fee Offer'} />
        <Modal.Content style={{ maxHeight: 300, overflow: 'auto' }} className="branch-form">
          <Form onSubmit={this.onSavePress}>
            {action === 'new' && (
              <Form.Group widths="equal">
                <RestaurantsField
                  restaurants={restaurants}
                  value={selectedMerchant}
                  onChange={value => this.setState({ selectedMerchant: value })}
                />
                <BranchesField
                  allBranches={this.generateMerchantBranches()}
                  value={selectedBranch}
                  onChange={value => this.setState({ selectedBranch: value })}
                />
              </Form.Group>
            )}

            <Form.Group widths="equal">
              <DeliveryDiscountField
                value={deliveryDiscount}
                onChange={value => this.setState({ deliveryDiscount: Number(value) })}
              />
              {smallOrderFee && (
                <ProfitMarginField
                  value={profitMargin}
                  onChange={value => this.setState({ profitMargin: Number(value) })}
                />
              )}
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Checkbox
                  label="Active"
                  checked={active}
                  onChange={() => this.setState({ active: !active })}
                />
              </Form.Field>
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Checkbox
                  label="Small Order Fee"
                  checked={smallOrderFee}
                  onChange={() => this.setState({ smallOrderFee: !smallOrderFee, profitMargin: 0 })}
                />
              </Form.Field>
            </Form.Group>

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Close</Button>
          <Button
            icon
            color="black"
            disabled={saving}
            loading={saving}
            onClick={() => this.btnSubmitRef.click()}
          >
            <Icon name="checkmark" /> {action === 'new' ? 'Save' : 'Update'}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/deliveryFeeOfferForm.js